import type { SkjvDesktop } from './skjv-desktop';

/** True when the SPA is running inside the SKJV Desktop shell. */
export function isDesktop(): boolean {
  return typeof window !== 'undefined' && window.skjvDesktop !== undefined;
}

/** The preload bridge; undefined in the browser. */
export function getDesktop(): SkjvDesktop | undefined {
  return typeof window !== 'undefined' ? window.skjvDesktop : undefined;
}
